import { withProps } from 'recompose'
import React from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from 'react-share'

const GeneralButton = ({ Button, Icon, shareProps, ...other }) => (
  <Button {...other} {...shareProps}>
    <Icon size={32} round={true} />
  </Button>
)

const addHash = h => '#' + h

const TwitterButton = withProps(ownProps => ({
  shareProps: {
    url: ownProps.url,
    title: ownProps.message,
    hashtags: [ownProps.hashtag],
  },
  Button: TwitterShareButton,
  Icon: TwitterIcon,
}))(GeneralButton)

const FacebookButton = withProps(ownProps => ({
  shareProps: {
    url: ownProps.url,
    quote: ownProps.message,
    hashtag: addHash(ownProps.hashtag),
  },
  Button: FacebookShareButton,
  Icon: FacebookIcon,
}))(GeneralButton)

const LinkedinButton = withProps(ownProps => ({
  shareProps: {
    url: ownProps.url,
    title: ownProps.message,
    description: addHash(ownProps.hashtag),
  },
  Button: LinkedinShareButton,
  Icon: LinkedinIcon,
}))(GeneralButton)

export default {
  facebook: FacebookButton,
  twitter: TwitterButton,
  linkedin: LinkedinButton,
}



// WEBPACK FOOTER //
// ./src/addons/social/buttons.js